import i18n from "@/localization/i18next";

export enum questionGroups {
    Goals = "goals",
    Fitness = "fitnesslevel",
    Lifestyle = "lifestyle",
    LifestyleAndHabits = "lifestyleAndHabits",
    NutritionHabits = "nutritionHabits",
    Personal = "personalDetails",
    Location = "location",
    WorkoutPreferences = "workoutPreferences",
    CalisthenicsWorkoutPreferences = "calisthenicsWorkoutPreferences",
    Motivation = "motivation",
    WorkoutSettings = "workoutSettings",
    ZingAi = "zingAI",
    BodyMetrics = "bodyMetrics",
    HealthCondition = "healthCondition",
    TrainingPreferences = "trainingPreferences",
    PhysicalParameters = "physicalParameters",
    MotivationAndSupport = "motivationSupport",
    MyProfile = "myProfile",
    PlanDetails = "planDetails",
    Activity = "activity",
    Nutrition = "nutrition",
    PlanPersonalization = "planPersonalization",
}

export const questionGroupsTitles = {
    [questionGroups.Goals]: i18n.t("goals"),
    [questionGroups.Fitness]: i18n.t("fitness_level"),
    [questionGroups.Lifestyle]: i18n.t("lifestyle_prompt"),
    [questionGroups.LifestyleAndHabits]: i18n.t("lifestyle_and_habits"),
    [questionGroups.NutritionHabits]: i18n.t("nutrition_habits"),
    [questionGroups.Personal]: i18n.t("personal_details"),
    [questionGroups.Location]: i18n.t("location"),
    [questionGroups.CalisthenicsWorkoutPreferences]: "Calisthenics Workout Preferences",
    [questionGroups.WorkoutPreferences]: i18n.t("workout_preferences_prompt"),
    [questionGroups.Motivation]: i18n.t("motivation"),
    [questionGroups.WorkoutSettings]: i18n.t("workout_settings"),
    [questionGroups.ZingAi]: "Zing AI",
    [questionGroups.BodyMetrics]: "Body Metrics",
    [questionGroups.HealthCondition]: "Health Condition",
    [questionGroups.TrainingPreferences]: "Training Preferences",
    [questionGroups.PhysicalParameters]: "Physical Parameters",
    [questionGroups.MotivationAndSupport]: "Motivation & Support",
    [questionGroups.MyProfile]: i18n.t("my_profile"),
    [questionGroups.PlanDetails]: i18n.t("plan_details"),
    [questionGroups.Activity]: i18n.t("activity"),
    [questionGroups.Nutrition]: i18n.t("nutrition"),
    [questionGroups.PlanPersonalization]: i18n.t("plan_personalization"),
};
